import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 4rem;
	row-gap: 0;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const LeftColumn = styled.div`
	grid-column: 1;
	grid-row: 1;
`;

export const RightColumn = styled.div`
	grid-column: 2;
	grid-row: 1;
	display: flex;
	flex-direction: column;

	@media (max-width: 768px) {
		grid-column: 1;
		grid-row: 3;
		margin-top: 1.5rem;
	}
`;

export const CaptionRow = styled.div`
	grid-column: 1;
	grid-row: 2;

	@media (max-width: 768px) {
		grid-column: 1;
		grid-row: 2;
	}
`;

export const ContactImage = styled.img`
	width: 100%;
	height: auto;
	border-radius: 8px;
`;

export const Caption = styled.p`
	text-align: center;
	font-style: italic;
	color: #555;
	font-size: 0.9rem;
	margin-top: 1rem;

	@media (max-width: 768px) {
		text-align: left;
	}
`;

export const ContactTitle = styled.h3`
	margin-bottom: 0.5rem;
`;

export const ContactDetail = styled.p`
	font-size: clamp(1rem, 1.8vw, 1.1rem);
	line-height: 1.6;
	margin-bottom: 1.5rem;
	color: var(--color-text-primary, #333);
	text-align: justify;

	a {
		color: #2980b9;
		text-decoration: underline;
		&:hover {
			color: #1a5276;
		}
	}

	@media (max-width: 768px) {
		text-align: left;
	}
`;

export const MapWrapper = styled.div`
	flex: 1;
	width: 100%;
	margin-top: 1.5rem;
	border-radius: 8px;
	overflow: hidden;

	@media (max-width: 768px) {
		min-height: 250px;
	}
`;

export const MapIframe = styled.iframe`
	width: 100%;
	height: 100%;
	border: 0;
	display: block;
`;


